import { render, staticRenderFns } from "./PowerSettingsOutlined.vue?vue&type=template&id=387ff2fa&"
import script from "./PowerSettingsOutlined.vue?vue&type=script&lang=js&"
export * from "./PowerSettingsOutlined.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports